import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updEventData } from "../../../../../ReduxSlice/Event/eventSlice";
import MainComponentWrapper from "../../../../Common/MainComponentWrapper";
import { EventById, createEmailSms } from "../../../../../utils/ApiConstant";
import Input from "../../../../UiElement/FormElement/Input";
import { useEffect, useState } from "react";
import useHttpHook from "../../../../../Hooks/HttpHook";
import { EmailSmsLanguage } from "../../../../../utils/SettingsLanguages";
import SubmitButtonGroup from "../../../../UiElement/FormElement/SubmitBtnGroup";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../../utils/notify";

const EmailSmsSetting = (props) => {
  const [dateTimeError, setDateTimeError] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, sendRequest, error] = useHttpHook();
  const { eventId } = useParams();
  const [showSpecificForm, setshowSpecificForm] = useState(false);
  const { EmailSmsForm } = EmailSmsLanguage;
  const eventData = useSelector((state) => state.event);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!eventData.status) {
      getEventData();
    }
    showingFormData();
  }, [props]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const showingFormData = () => {
    if (props.emailSmsData) {
      setshowSpecificForm("email");
      let differentFormValues;
      if (props.emailSmsData.notificationType == "email") {
        differentFormValues = {
          emailName: props.emailSmsData.name,
          replyToEmail: props.emailSmsData.replyTo,
          emailSub: props.emailSmsData.subject,
          emailMsg: props.emailSmsData.message,
        };
      } else {
        setshowSpecificForm("sms");
        differentFormValues = {
          smsName: props.emailSmsData.name,
          replyToSms: props.emailSmsData.replyTo,
          smsSubject: props.emailSmsData.subject,
          messageForSms: props.emailSmsData.message,
        };
      }
      reset({
        ...differentFormValues,
        _id: props.emailSmsData._id,
        includeEventDetails: props.emailSmsData.includeEventDetails,
        dateTime: props.emailSmsData.sendNotification.dateTime,
      });
    }
  };

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
  };

  const onSubmit = async (data) => {
    const hasEmailContent =
      Boolean(data.replyToEmail?.trim()) ||
      Boolean(data.emailSub?.trim()) ||
      Boolean(data.emailMsg?.trim()) ||
      Boolean(data.dateTime);

    if (!hasEmailContent) {
      props.ClickHandler("email");
      return;
    }

    if (data.dateTime && new Date(data.dateTime) < new Date(Date.now())) {
      setDateTimeError("Date should be greater than or equal to current Date");
      return;
    }
    setDateTimeError("");
    const createSms = await sendRequest(createEmailSms + eventId, {
      method: "post",
      data,
    });
    dispatch(updEventData(createSms));
    props.ClickHandler("email");
  };

  if (showSpecificForm && showSpecificForm !== "email") {
    return null;
  }

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <form
        className="event-settings-email-panel"
        onSubmit={handleSubmit(onSubmit)}
      >
        <h3 className="event-settings-subtitle">
          {EmailSmsForm.CustomizeEmailText}
        </h3>
        <p className="event-settings-note">{EmailSmsForm.CustomizeEmailDesc}</p>

        <Input
          element="email"
          placeholder="reply-to@example.com"
          Register={register}
          Errors={errors}
          FieldName="replyToEmail"
          Label="Reply-To Email"
          CustomFormGroupCls="event-create-field"
          InputClassName="event-create-input"
        />
        <Input
          element="text"
          placeholder="Email subject"
          Register={register}
          Errors={errors}
          FieldName="emailSub"
          Label="Subject"
          CustomFormGroupCls="event-create-field"
          InputClassName="event-create-input"
        />
        <Input
          element="textarea"
          rows="8"
          placeholder="Write your email message"
          Register={register}
          Errors={errors}
          FieldName="emailMsg"
          Label="Message for Email"
          CustomFormGroupCls="event-create-field"
          InputClassName="event-create-textarea event-settings-email-message"
        />

        <div className="event-settings-send-email">
          <h3 className="event-settings-subtitle">Send Email</h3>
          <Input
            element="datetime-local"
            placeholder="Date and Time"
            Register={register}
            Errors={errors}
            FieldName="dateTime"
            Label="Date and Time"
            CustomFormGroupCls="event-create-field"
            InputClassName="event-create-input event-create-input--datetime"
          />
          {dateTimeError && (
            <p className="event-ticket-field-error">{dateTimeError}</p>
          )}
        </div>

        <SubmitButtonGroup
          cancelButtonclickHandler={() => {
            props.ClickHandler(props.emailSmsData?.notificationType);
          }}
          isLoading={loading}
          GroupClassName="event-settings-footer"
        />
      </form>
    </MainComponentWrapper>
  );
};

export default EmailSmsSetting;
